export class DayHeatMap {
	day: number;
	hours: { [key: number]: HourHeatMap } = {};
	total: number = 0;

	constructor(day: number) {
		this.day = day;
		for (let i = 0; i < 24; i += 2) {
			this.hours[i] = new HourHeatMap(i, i + ":00 - " + (i + 2) + ":00");
		}
	}
}

export class HourHeatMap {
	hourId: number;
	display: string;
	value: number = 0;

	constructor(hourId: number, display: string) {
		this.hourId = hourId;
		this.display = display;
	}
}

export class HeatMapResponse {
	day: number;
	hourGroup: number;
	id: number;
	numInvoices: number;
}